<template>
  <v-container id="reset-password-confirm-view" class="fill-height" tag="section">
    <v-row justify="center">
      <v-col cols="12" md="9" lg="6">
        <v-slide-y-transition appear>
          <v-card flat class="pa-3 pa-md-10 mx-sm-auto">
            <company-logo />

            <PasswordForm
              ref="form"
              :valid.sync="valid"
              :newPassword1.sync="newPassword1"
              :newPassword2.sync="newPassword2"
              :username="currentUsername"
              :requireCurrentPassword="false"
              @submit="changePassword"
            />
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import passwordChangeMixin from '@/mixins/passwordChange'
import PasswordForm from '@/components/PasswordForm'

export default {
  mixins: [passwordChangeMixin],

  components: {
    PasswordForm
  },

  computed: {
    currentUsername() {
      // Try multiple possible paths in the store
      const state = this.$store.state
      return state.auth?.user?.email ||
             state.auth?.user?.username ||
             state.user?.email ||
             state.user?.username ||
             ''
    }
  },

  methods: {
    changePassword() {
      this.handlePasswordChange({ redirectAfterSuccess: true })
    }
  }
}
</script>
